import type { ReactElement } from "react";
import styles from "./NorthCompass.module.css";

/**
 * Must keep `<g id="north-arrow-rotor">` for {@link bindNorthArrow}.
 */
export function NorthCompass(): ReactElement {
  return (
    <div className={styles.root} title="North">
      <svg viewBox="0 0 64 64" aria-hidden="true" className={styles.svg}>
        <circle
          cx="32"
          cy="32"
          r="29.5"
          fill="none"
          strokeWidth="1"
          className={styles.ring}
        />
        <g id="north-arrow-rotor">
          <polygon points="32,8 38,34 32,29 26,34" className={styles.needleNorth} />
          <polygon points="32,56 38,30 32,35 26,30" className={styles.needleSouth} />
        </g>
        <text
          x="32"
          y="6"
          textAnchor="middle"
          fontSize="9"
          fontFamily="-apple-system, sans-serif"
          fontWeight="600"
          className={styles.northLabel}
        >
          N
        </text>
      </svg>
    </div>
  );
}
